import { observable, action } from 'mobx'
import { Goods } from '@/model/types/goods'

class SelectGoodsStore {
    @observable
    activeId: number | undefined = void 0

    @observable
    keyWord: string = ''

    @observable
    secondId: number = 0

    @observable
    selectKey: number[] = []

    @observable
    selectList: Goods[] = []

    initSelectKey: number[] = []

    initSelectList: Goods[] = []

    @action
    reset() {
        this.activeId = void 0
        this.keyWord = ''
        this.secondId = 0
        this.selectKey = []
        this.selectList = []
    }

    setInitSelectKey(key: number[]) {
        this.initSelectKey = key
    }

    setInitSelectList(list: Goods[]) {
        this.initSelectList = list
    }

    @action
    setActiveId(id: number | undefined) {
        this.activeId = id
    }

    @action
    setSecondId(id: number) {
        this.secondId = id
    }

    @action
    setSelectKey(key: number[]) {
        this.selectKey = key
    }

    @action
    setSelectList(goods: Goods[]) {
        this.selectList = goods
    }

    @action
    setKeyword(key: string) {
        this.keyWord = key
    }
}

export const selectGoodStore = new SelectGoodsStore()
